import * as React from 'react';

import { Translate } from 'react-localize-redux';
import { SortableContainer } from 'react-sortable-hoc';

import { Ownership } from '@services/ownership/types/ownership';

import styled from 'styled-components';

import OwnershipRowCtrl from './ownership-row';

import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

interface OwnershipListCtrlProps {
  className?: string;
  request?: boolean;
  userId?: string;
  ownership: Ownership[];
  leftDecoration?: any;
  isRequest?: boolean;
  disabled?: boolean;
  removedByUser?: string;
  givePercentUsername?: string;
  lockedPeriod?: boolean;
  withoutGiveMessage?: boolean;
  onRemove: (ownerId: string) => void;
  updateCurrentSplit: (ownerId: string, newSplit: number) => void;
  updateOwnershipOrder: (oldIndex: number, newIndex: number) => void;
  updateRequestNewSplit: (ownerId: string, newSplit: number) => void;
}

export const OwnershipListCtrl = SortableContainer<OwnershipListCtrlProps>(
  (props: OwnershipListCtrlProps) => {
    return (
      <GridWrapper
        className={`${props.className} ${props.disabled ? 'disabled' : ''}`}
        gap={5}
      >
        {props.ownership.map((owner, index) => (
          <React.Fragment
            key={`ownership-split-editor-${
              owner.id
                ? owner.id
                : `${owner.ownerType}#${owner.ownershipType}#${owner.ownerId}`
            }`}
          >
            {owner.ownerId !== props.userId &&
              (owner.requestedSplit === 0 || owner.requestedSplit) && (
                <RequestText weight="700">
                  <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.REQUESTED" />
                </RequestText>
              )}
            <OwnershipRowCtrl
              index={index}
              owner={owner}
              locked={
                (props.request && owner.ownerId !== props.userId) ||
                props.disabled
              }
              request={props.request}
              lockedPeriod={props.lockedPeriod}
              userId={props.userId}
              onRemove={() =>
                props.onRemove(
                  owner.id ||
                    `${owner.ownerType}#${owner.ownershipType}#${owner.ownerId}`
                )
              }
              requestNewSplit={(value: number) =>
                props.updateRequestNewSplit(owner.id, value)
              }
              updateCurrentSplit={(value: number) =>
                props.updateCurrentSplit(
                  owner.id ||
                    `${owner.ownerType}#${owner.ownershipType}#${owner.ownerId}`,
                  value
                )
              }
              ownerShip={props.ownership}
              leftDecoration={props.leftDecoration}
              isRequest={props.isRequest || !!props.givePercentUsername}
              removedByUser={props.removedByUser}
              givePercentUsername={owner.name}
              withoutGiveMessage={props.withoutGiveMessage}
            />
          </React.Fragment>
        ))}
      </GridWrapper>
    );
  }
);

export default (props: OwnershipListCtrlProps) => (
  <OwnershipListCtrl
    {...props}
    onSortEnd={(newSort) =>
      props.updateOwnershipOrder(newSort.oldIndex, newSort.newIndex)
    }
    useDragHandle
    lockAxis="y"
    lockToContainerEdges
    helperClass="sorting"
  />
);

const GridWrapper = styled(Grid)`
  &.disabled {
    opacity: 0.25;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

const RequestText = styled(Typography)`
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.upload};
`;
